package com.milta.core.localization.translations.nl

import com.milta.core.localization.HomeStrings

internal val Home = HomeStrings(
    navTournee = "Route",
    navEcoDriving = "Eco-rijden",
    navCommunity = "Community",
    navRewards = "Beloningen",
    navHome = "Start",
    navRoutes = "Ritten",
    navTeam = "Team",
    navProfile = "Profiel",
)
